import * as axios from 'axios';
import qs from 'qs';

const baseUrlPath = '/api/8p2reporting'

const headers = {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    'Access-Control-Allow-Origin': '*'
};





function getInspection(projectNumber, inspection) {

    const data = qs.stringify({
        projectNumber: projectNumber,
        inspection: inspection
    });

    const url = baseUrlPath + `/get-inspection`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function getInspections(projectNumber) {

    const data = qs.stringify({
        projectNumber: projectNumber
    });

    const url = baseUrlPath + `/inspections`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function getChapterSettings(projectNumber, inspection, chapterId) {

    const data = qs.stringify({
        projectNumber: projectNumber,
        inspection: inspection,
        chapterId: chapterId,
    });

    const url = baseUrlPath + `/get-chapter-settings`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function saveChapterSettings(projectNumber, inspection, chapterId, chapterSettings) {

    const data = qs.stringify({
        projectNumber: projectNumber,
        inspection: inspection,
        chapterId: chapterId,
        chapterSettings: chapterSettings
    });

    const url = baseUrlPath + `/save-chapter-settings`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}


function updateChapterMarker(projectNumber, inspection, chapterId, results, resultImage) {

    const data = qs.stringify({
        projectNumber: projectNumber,
        inspection: inspection,
        chapterId: chapterId,
        results: results,
        resultImage: resultImage
    });


    const url = baseUrlPath + `/update-chapter-marker`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function getImgLib() {

    const data = qs.stringify({

    });

    const url = baseUrlPath + `/get-imagelib`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function getProjectImgLib(project_uid) {

    const data = qs.stringify({
        project_uid: project_uid
    });

    const url = baseUrlPath + `/get-projectimagelib`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}


function renameImgLib(uid, name) {
    const data = qs.stringify({
        file_uid: uid,
        file_name: name
    });

    const url = baseUrlPath + `/rename-imagelib`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}



function removeImgLib(uid, file) {
    const data = qs.stringify({
        file_uid: uid,
        file_file: file
    }); 

    const url = baseUrlPath + `/remove-imagelib`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}


function removeProjectImgLib(uid, file, project_uid) {
    const data = qs.stringify({
        file_uid: uid,
        file_file: file,
        project_uid: project_uid
    }); 

    const url = baseUrlPath + `/remove-projectimagelib`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function getReportSettings(projectNumber, inspection, projectUid) {
    const data = qs.stringify({
        projectNumber: projectNumber,
        inspection: inspection,
        projectUid: projectUid
    }); 

    const url = baseUrlPath + `/get-report-settings`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function saveReportSettings(projectNumber, inspection, reportData) {
    const data = qs.stringify({
        projectNumber: projectNumber,
        inspection: inspection,
        reportData: reportData
    }); 

    const url = baseUrlPath + `/save-report-settings`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}

function generateReport(projectNumber, inspection) {
    const data = qs.stringify({
        projectNumber: projectNumber,
        inspection: inspection
    }); 

    const url = baseUrlPath + `/generate-pdf`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}


function getMainReportSettings() {
    const data = qs.stringify({

    }); 

    const url = baseUrlPath + `/get-mainreport-settings`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}


function saveMainReportSettings(settings) {
    const data = qs.stringify({
        settings: settings
    }); 

    const url = baseUrlPath + `/save-mainreport-settings`;
    return axios.post(url, data, headers)
        .then(x => x.data)
        .then(x => {
            return x
        });
}


export {
    getInspections,
    getChapterSettings,
    saveChapterSettings,
    getInspection,
    updateChapterMarker,
    getImgLib,
    renameImgLib,
    removeImgLib,
    removeProjectImgLib,
    getProjectImgLib,
    getReportSettings,
    saveReportSettings,
    generateReport,
    getMainReportSettings,
    saveMainReportSettings
}

